import React from "react";
import { PAGE_SIZE } from "./constants";

const Pagination = ({ page, pageCount, onChange, total }) => (
  <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
    <p className="text-[12px] text-gray-500 font-medium">
      Showing <span className="font-bold text-gray-900">
        {Math.min(total, (page - 1) * PAGE_SIZE + 1)}–{Math.min(total, page * PAGE_SIZE)}
      </span>{" "}
      of <span className="font-bold text-gray-900">{total}</span>
    </p>
    <div className="flex items-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="p-1.5 rounded-lg border border-gray-200 hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed"
      >
        ‹
      </button>
      {Array.from({ length: pageCount }, (_, i) => i + 1).map((p) => (
        <button
          type="button"
          key={p}
          onClick={() => onChange(p)}
          className={`w-8 h-8 flex items-center justify-center rounded-lg text-[12px] font-medium transition-colors ${
            p === page ? "bg-purple-700 text-white" : "hover:bg-white"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(pageCount, page + 1))}
        disabled={page === pageCount}
        className="p-1.5 rounded-lg border border-gray-200 hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed"
      >
        ›
      </button>
    </div>
  </div>
);

export default Pagination;
